const sizeCalculator = (
  mediaType: string,
  textContent: string,
  length: number
): object => {
  switch (mediaType) {
    case "digital":
      return {
        value: `${Number(textContent?.length)} letters`,
        label: "Article size",
      };
    case "radio":
      return { value: `${Number(length)} seconds`, label: "Audio length" };
    case "tv":
      return { value: `${Number(length)} seconds`, label: "Video length" };
    case "print":
      return {
        value: `${Number(textContent?.length)} letters`,
        label: "Article size",
      };
    default:
      return {
        value: `${Number(textContent?.length)} letters`,
        label: "Article size",
      };
  }
};

export default sizeCalculator;
